import { Box, HStack, VStack } from "@chakra-ui/react";
import {
  AddCircle as AddCircleIcon,
  DeleteOutline as DeleteOutlineIcon,
} from "@mui/icons-material";
import { FieldArray, useField } from "formik";
import { FC } from "react";

import { SymbolOutlineButton } from "~/src/components/common/Button";
import { FormControl } from "~/src/components/common/forms/FormControl";
import {
  FormikSelectField,
  type FormikSelectFieldProps,
} from "~/src/components/common/forms/FormikSelectField";
import { IconButton } from "~/src/components/common/IconButton";

export type ScheduleListSelectProps = Omit<
  FormikSelectFieldProps,
  "name" | "options"
>;

export type Props = {
  options: ReadonlyArray<{ label: string; value: string }>;
  name: string;
  label: string;
  /** Extra props for each row select (e.g. menuPortalTarget in scroll containers). */
  selectProps?: ScheduleListSelectProps;
};

export const ScheduleListField: FC<Props> = ({
  options,
  name,
  label,
  selectProps,
}) => {
  const [scheduleIds, ,] = useField<string[]>(name);

  const hideLabel = label === "";

  return (
    <FieldArray
      name={name}
      // eslint-disable-next-line react/jsx-no-bind
      render={(arrayHelpers) => (
        <FormControl label={label} hideLabel={hideLabel}>
          <VStack width="100%" alignItems="flex-start">
            {scheduleIds.value &&
              scheduleIds.value.map((id, index) => (
                <HStack key={`${id}-${index}`} width="258px">
                  <Box flex={1}>
                    <FormikSelectField
                      name={`${name}.${index}`}
                      options={options}
                      {...selectProps}
                    />
                  </Box>
                  <Box>
                    <IconButton
                      size="24px"
                      // eslint-disable-next-line react/jsx-no-bind
                      onClick={() => arrayHelpers.remove(index)}
                      icon={<DeleteOutlineIcon />}
                    />
                  </Box>
                </HStack>
              ))}
            <Box width="100%">
              <SymbolOutlineButton
                icon={<AddCircleIcon />}
                // eslint-disable-next-line react/jsx-no-bind
                onClick={() => arrayHelpers.push("")}
              >
                スケジュールを追加
              </SymbolOutlineButton>
            </Box>
          </VStack>
        </FormControl>
      )}
    />
  );
};
